import { OverlayHeaderBannerAsset, OverlayHeaderBannerAssetKey } from "@swiggy-private/cart-types";
import { isEmpty } from "@swiggy-private/js-utils";

export interface OverlayHeaderBannerResolvedAssets {
    backgroundBannerAssetId: string | undefined;
    rightImageAssetId: string | undefined;
}

export function getOverlayHeaderBannerAssets(assets?: OverlayHeaderBannerAsset[]): OverlayHeaderBannerResolvedAssets {
    if (isEmpty(assets)) return { backgroundBannerAssetId: "", rightImageAssetId: "" };

    const backgroundBannerAssetId = assets.find(
        (asset) => asset.asset_key === OverlayHeaderBannerAssetKey.BackgroundBanner,
    )?.asset_value;

    const rightImageAssetId = assets.find(
        (asset) => asset.asset_key === OverlayHeaderBannerAssetKey.RightImage,
    )?.asset_value;

    return { backgroundBannerAssetId, rightImageAssetId };
}
